import {Component} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";

@Component({
	templateUrl: './details.component.html'
})
export class DetailsComponent extends InfoModalComponent {
	detailLoader: boolean = false;
	details: any;
	
	ok() {
		this.close();
	}
}
